import { render, staticRenderFns } from "./FaceDetectorTest.vue?vue&type=template&id=61971079&scoped=true&"
import script from "./FaceDetectorTest.vue?vue&type=script&lang=js&"
export * from "./FaceDetectorTest.vue?vue&type=script&lang=js&"
import style0 from "./FaceDetectorTest.vue?vue&type=style&index=0&id=61971079&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61971079",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61971079')) {
      api.createRecord('61971079', component.options)
    } else {
      api.reload('61971079', component.options)
    }
    module.hot.accept("./FaceDetectorTest.vue?vue&type=template&id=61971079&scoped=true&", function () {
      api.rerender('61971079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/test/camera/media-pipe/face-detector/FaceDetectorTest.vue"
export default component.exports